'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var react = require('@chakra-ui/react');
var utils = require('@chakra-ui/utils');
var React = require('react');
var CircularProgress = require('../CircularProgress/CircularProgress.js');
var CircularProgressIcon = require('../CircularProgress/CircularProgressIcon.js');
var BrokerLeadCard = require('./BrokerLeadCard.js');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var _excluded = ["className", "value"];
/**
 * BrokerLeadCardIcon
 *
 * Displaying the right icon to its porperty type.
 * The prop 'realtyType' on the card sets the right icon.
 */
var BrokerLeadCardIcon = react.forwardRef(function (props, ref) {
  var _BROKER_REALTY_TYPES$;
  var className = props.className,
    value = props.value,
    rest = _objectWithoutProperties__default["default"](props, _excluded);
  var _useBrokerLeadCardCon = BrokerLeadCard.useBrokerLeadCardContext(),
    realtyType = _useBrokerLeadCardCon.realtyType;
  var realtyIcon = (_BROKER_REALTY_TYPES$ = BrokerLeadCard.BROKER_REALTY_TYPES[realtyType]) === null || _BROKER_REALTY_TYPES$ === void 0 ? void 0 : _BROKER_REALTY_TYPES$.icon;
  var styles = react.useStyles();
  if (!realtyIcon) return /*#__PURE__*/React__default["default"].createElement(react.chakra.div, rest);

  // Progress should be not shown with an undefined or null value, but should
  // be shown with a `0` value (empty progress circle).
  if (value === null || value === undefined) {
    return /*#__PURE__*/React__default["default"].createElement(react.chakra.div, _extends__default["default"]({
      height: styles.icon.boxSize,
      className: utils.cx('chakra-broker-lead-card__icon', className),
      ref: ref
    }, rest), /*#__PURE__*/React__default["default"].createElement(react.Icon, {
      as: realtyIcon,
      __css: styles.icon
    }));
  }
  return /*#__PURE__*/React__default["default"].createElement(CircularProgress.CircularProgress, _extends__default["default"]({
    size: styles.icon.boxSize,
    className: utils.cx('chakra-broker-lead-card__icon', className),
    value: value,
    ref: ref
  }, rest), /*#__PURE__*/React__default["default"].createElement(CircularProgressIcon.CircularProgressIcon, {
    as: realtyIcon
  }));
});
BrokerLeadCardIcon.displayName = 'BrokerLeadCardIcon';
exports.BrokerLeadCardIcon = BrokerLeadCardIcon;